



















// https://dev.to/kouts/create-wrapper-components-for-vuetify-components-2aah
import { Vue, Component } from 'nuxt-property-decorator';

@Component({
  inheritAttrs: false
})
export default class CustomSwitch extends Vue {
  get commonAttrs() {
    return {
      ripple: false,
      flat: true,
      inset: true,
      hideDetails: true
    };
  }
}
